import type { Participant } from '@seen/core/models/patients/participant'
import * as questionnaires from '@seen/core/models/questionnaires/index'
import { ExtendedRelatedPerson } from '@seen/core/models/relatedPerson'
import { IconSos } from '@tabler/icons-react'
import type { JSX } from 'react'
import { CareTeamCard } from '#src/components/patient/detail-content/contact-tab/CareTeamCard.tsx'
import { ParticipantCard } from '#src/components/patient/detail-content/contact-tab/ParticipantCard.tsx'
import { RelatedPersonCard } from '#src/components/patient/detail-content/contact-tab/RelatedPersonCard.tsx'
import {
  FacesheetCard,
  FacesheetCardCollapseTrigger,
  FacesheetCardContent,
  FacesheetCardHeader,
  FacesheetCardIcon,
  FacesheetCardLabel,
  FacesheetCardTitle,
} from '#src/components/patient/detail-content/facesheet/index.ts'
import { InsuranceCard } from '#src/components/patient/detail-content/InsuranceCard.tsx'
import { QuestionnaireForm } from '#src/components/questionnaire-form/QuestionnaireForm.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'

export function ContactTab({
  participant,
}: {
  participant: Participant
}): JSX.Element {
  const relatedPersonsQuery = useSearch(
    ExtendedRelatedPerson,
    ExtendedRelatedPerson.byParticipant(participant)
  )
  return (
    <div className="grid gap-4">
      <ParticipantCard participant={participant} />
      <InsuranceCard participant={participant} />
      {relatedPersonsQuery.data?.map((relatedPerson) => (
        <RelatedPersonCard
          key={relatedPerson.id}
          relatedPerson={relatedPerson}
        />
      ))}
      <FacesheetCard rumName="emergency_contacts">
        <FacesheetCardHeader>
          <FacesheetCardTitle>
            <FacesheetCardIcon>
              <IconSos />
            </FacesheetCardIcon>
            <FacesheetCardLabel>Emergency</FacesheetCardLabel>
            <FacesheetCardCollapseTrigger />
          </FacesheetCardTitle>
        </FacesheetCardHeader>
        <FacesheetCardContent>
          <QuestionnaireForm
            questionnaire={
              questionnaires.EmergencyContactAndDecisionsQuestionnaire
            }
            participant={participant}
          />
        </FacesheetCardContent>
      </FacesheetCard>
      <CareTeamCard participant={participant} />
    </div>
  )
}
